<eo-search-page
  [formConfig]="formConfig"
  [tableConfig]="tableConfig"
  [searchServ]="searchService"
  [page]="getPage()"
  [pagesize]="getPagesize()"
  [totalCount]="getTotalCount()"
  [loading]="isLoading()"
  [viewModeVisible]="false"
  [menuActions]="[]"
  (search)="onSearch($event)"
>
  <ng-container actions>
    <p-button
      size="small"
      label="Νέος Χρήστης"
      [ariaLabel]="'Νέος Χρήστης'"
      icon="pi pi-plus"
      [disabled]="isLoading()"
      (onClick)="onCreateUser()"
    />
    <p-button
      *ngIf="isAdmin()"
      size="small"
      label="Export Excel"
      [ariaLabel]="'Export Excel'"
      [style]="{ 'background-color': '#005946' }"
      severity="success"
      icon="pi pi-file-excel"
      iconPos="left"
      (onClick)="onExportExcel()"
      [disabled]="isLoading() || isExportingExcel || !canExportExcel"
      [loading]="isLoading() || isExportingExcel"
    />
  </ng-container>
</eo-search-page>

<app-user-form-dialog #userFormDialog (success)="onUserFormSuccess()" />

<p-confirmPopup key="approveResetPopup" [style]="{ width: '700px' }">
</p-confirmPopup>
